module.exports = __webpack_public_path__ + "img/milestone-asset-1.ee53e332.png";